import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap'

function menuButton() {
  if(!$qs('body').classList.contains('page-template-landing-page')) {
  // Add needed classes to the menu - ex. current-page-ancestor
  let activeMenuItem = document.querySelector('.current-page-item')

  if (activeMenuItem) {
    activeMenuItem.parentNode?.parentNode?.classList.add(
      'current-page-ancestor'
    )
  }

  const hamburgerWrapper = document.querySelector('.hamburger-menu-wrapper')
  const hamburgerMenu = document.querySelector('.hamburger-menu')
  const hamburgerBG = document.querySelector('.hamburger-menu-bg')
  const parentPortalButton = document.querySelector(
    '[data-target="parent-portal-button"]'
  )

  const menus = document.querySelector('.top-nav .menus')
  const subMenus = document.querySelectorAll('.top-nav .menus .sub-menu')
  const mainMenuItems = document.querySelectorAll(
    '.top-nav .menus #main-menu > li.menu-item > .link-container'
  )
  const hasChildren = document.querySelectorAll(
    '.top-nav .menus #main-menu .menu-item-has-children > .link-container > a'
  )
  const hasNoChildren = document.querySelectorAll(
    '.top-nav .menus .menu-item:not(.menu-item-has-children) > .link-container > a'
  )
  const menuContainer = document.querySelector('.top-nav-menu-container')
  const backLink = document.querySelectorAll(
    '.top-nav-menu-container .menu-back'
  )

  let isMobile = false
  if ($(window).width() < 769) {
    isMobile = true
  }

  const backOverlay = document.querySelector('.back-overlay')
  const backToBlur = document.querySelector('#content-wrap')
  // Open and close menu - Hamburger clicks.
  hamburgerWrapper.addEventListener(
    'click',
    function () {
      hamburgerWrapper.classList.toggle('open')
      hamburgerMenu.classList.toggle('active')
      hamburgerBG.classList.toggle('bg-white')
      //   parentPortalButton.classList.toggle('opacity-0')
      parentPortalButton.classList.toggle('pointer-events-none')
      $('.line').toggleClass('bg-purple')
      $('.line').toggleClass('bg-white')

      if (hamburgerWrapper.classList.contains('open')) {
        // Opening the menu
        menuContainer.classList.add('open')

        let tl = gsap.timeline()
        tl.to(menus, { x: 0 })
          .to(parentPortalButton, { alpha: 1 }, '<')
          .to(backToBlur, { filter: 'blur(8px)' }, '<')
          .fromTo(
            mainMenuItems,
            { alpha: 0, y: 50 },
            { alpha: 1, y: 0, stagger: 0.1 }
          )

        // Open submenu if in current subpage.
        mainMenuItems.forEach((menuItem) => {
          if (menuItem.parentNode.classList.contains('current-page-ancestor')) {
            menuItem.querySelector('a').click()
          }
        })
      } else {
        // Closing the menu
        menuContainer.classList.remove('open')

        let tl = gsap.timeline()

        tl.to(parentPortalButton, { alpha: 0, duration: 0.05 })
          .to(backOverlay, { opacity: 0 }, '<')
          .to(backToBlur, { filter: 'blur(0px)', duration: 0.5 }, '<')
          .to(
            menus,
            {
              x: isMobile ? '100vw' : '50vw',
            },
            '<'
          )
      }
    },
    false
  )

  // Open and close sub-menu - Menu item with children clicks.
  hasChildren.forEach((menuItem) => {
    menuItem.addEventListener(
      'click',
      function (e) {
        e.preventDefault()
        // reset
        hasChildren.forEach((item) => {
          item.classList.remove('sub-menu-open')
        })
        // add open menu class
        menuItem.classList.add('sub-menu-open')
        const subMenu = menuItem
          .closest('.menu-item')
          .querySelector('.sub-menu')
        const subMenuItems = subMenu.querySelectorAll('li.menu-item')

        // Opening the sub-menu
        let tl = gsap.timeline()

        if (isMobile) {
          tl.to(subMenus, { x: '100vw' }, '<')
            .to(subMenu, { x: '0vw' }, '<')
            .fromTo(
              subMenuItems,
              { alpha: 0, y: 50 },
              { alpha: 1, y: 0, stagger: 0.1 },
              '<+0.4'
            )
        } else {
          tl.to(backOverlay, { opacity: 1 })
            .to(menus, { x: '-50vw' })
            .to(subMenus, { x: '100vw' }, '<')
            .to(subMenu, { x: '50vw' }, '<')
            .fromTo(
              subMenuItems,
              { alpha: 0, y: 50 },
              { alpha: 1, y: 0, stagger: 0.1 },
              '<+0.4'
            )
        }
      },
      false
    )
  })

  // Close menu before loading a new page - Menu item clicks.
  hasNoChildren.forEach((menuItem) => {
    menuItem.addEventListener(
      'click',
      function (e) {
        // Closing the menu before load (if open in same page)
        if (!e.ctrlKey) {
          gsap.to('body', { alpha: 0, duration: 0.4 })
        }
      },
      false
    )
  })

  // Go back link on menu mobile version.
  backLink.forEach((back) => {
    back.addEventListener('click', function () {
      gsap.to(subMenus, { x: '100vw', ease: 'power2' })
    })
  })
}
}

export default menuButton
